import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import venueData from "../../data/venueData";

/**
 * WhatsAppButton — fixed floating action button linking to WhatsApp chat.
 */
export default function WhatsAppButton() {
  const digits = venueData.contact.whatsapp.replace(/\D/g, "");
  return (
    <a
      href={`https://wa.me/${digits}`}
      target="_blank"
      rel="noopener noreferrer"
      className="wa-fab"
      aria-label="Chat with Beejees Convention Centre on WhatsApp"
    >
      <FaWhatsapp size={26} />
    </a>
  );
}
